import styled from "styled-components";

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
  margin-right: 3rem;
  height: 50px;
  transition: opacity 0.5s ease-in-out;
  opacity: 1;

  &.loading {
    opacity: 0.2;
  }
`;

export const WaveformContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

export const ZoomControls = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  svg {
    box-sizing: border-box;
    width: 20px;
    height: 20px;
    fill: #fff;
    padding: 0.5rem;
    background: rgba(0, 0, 0, 0.7);
    cursor: pointer;
    transition: fill 0.2s;
  }
`;
